
/**
 *	globals:
 *
 *	Allgemeine states, die von verschiedenen components / views
 *	benötigt werden.
 *
 * 	Beispiel zum Ändern eines globalen Wertes von einer Komponente aus:
 * 	this.$store.commit('globals/SET_APP_ATTRIBUTES', obj);
 *
 * 	Zugriff auf Wert aus Komponente:
 * 	this.$store.state.globals
 *
 * 	Alternativ mapState() verwenden:
 * 	import { mapState } from 'vuex';
 * 	computed: {
 * 		...mapState('globals', ['app']),
 * 	}
 * 	Zugriff: this.app.innerWidth
 *
 */

import cssVars from 'css-vars-ponyfill';
import { EventBus } from '@/common/eventbus.js'

export const state = {
	language: '',
	languageUid: 0,
	animation: {
		a: 1
	},
	app: {

		// Höhe / Breite des Browser-Fensters
		windowWidth: 0,
		windowHeight: 0,

    	// Höhe / Breite der App. (#app-width)
		viewportWidth: 0,
		viewportHeight: 0,

		// Höhe / Breite der App abzüglich Höhe Tabbar und Navbar
		innerHeight: 0,
		innerWidth: 0,

	}
}


export const mutations = {

	/**
	 *  Attribute der App global setzen, z.B. Angaben über
	 *  den sichtbaren Viewport, die Fensterbreite etc.
	 *  Wird vorallem im CSS verwendet, um per CSS-Variablen die
	 *  Größe von Elementen zu berechnen.
	 */
	SET_APP_ATTRIBUTES(state, attributes) {
		state.app = Object.assign( state.app, attributes );

		state.app.innerWidth = state.app.viewportWidth;
		state.app.innerHeight = state.app.viewportHeight;

		// Update der CSS-Variablen
		cssVars({
			variables: {
				'windowWidth': `${state.app.windowWidth}px`,
				'windowHeight': `${state.app.windowWidth}px`,
				'viewportWidth': `${state.app.viewportWidth}px`,
				'viewportHeight': `${state.app.viewportHeight}px`,
				'tabbarHeight': `${state.app.tabbarHeight}px`,
				'navbarHeight': `${state.app.navbarHeight}px`,
				'innerHeight': `${state.app.innerHeight}px`,
				'innerWidth': `${state.app.innerWidth}px`,
			}
		});
	},

	SET_ANIMATION(state, attributes) {
		state.animation = Object.assign( state.animation, attributes );
	},

	SET_LANGUAGE(state, langKey) {
		state.language = langKey;
	},

	SET_LANGUAGE_UID(state, langUid) {
		state.languageUid = langUid;
	}

}

export const actions = {
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/globals.js